import * as Buttons from "./Buttons"

export const ButtonsUIConst = {
    [Buttons.ONE] : "1",
    [Buttons.TWO] : "2",
    [Buttons.THREE] : "3",
    [Buttons.FOUR] : "4",
    [Buttons.FIVE] : "5",
    [Buttons.SIX] : "6",
    [Buttons.SEVEN] : "7",
    [Buttons.EIGHT] : "8",
    [Buttons.NINE] : "9",
    [Buttons.ZERO] : "0",
    [Buttons.DOUBLE_ZERO] : "00",

    [Buttons.DOT] : ".",
    [Buttons.PLUS] : "+",
    [Buttons.MINUS] : "-",
    [Buttons.MULTIPLE] : "*",
    [Buttons.DIVIDE] : "/",
    [Buttons.EQUAL] : "=",
    [Buttons.SQRT] : "√",
    [Buttons.X2] : "x²",
    [Buttons.REVERSE] : "+/-",
    [Buttons.ONEDIVIDEX]: "1/x",
    [Buttons.PERCENT]: "%",

    //Service
    [Buttons.CLEAR] : "C",
    [Buttons.DELETE] : "<-"
}